import { render, staticRenderFns } from "./CoozzyFormCountryCitizenshipSelect.vue?vue&type=template&id=7cf948c3&scoped=true"
import script from "./CoozzyFormCountryCitizenshipSelect.vue?vue&type=script&lang=js"
export * from "./CoozzyFormCountryCitizenshipSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf948c3",
  null
  
)

export default component.exports